import useGreeksWebsocketDataStore from '../../Store/GreeksWebsocketDataStore';

export const deltaLevelsGetter = function (PineJS) {
 return Promise.resolve([
   {
     name: 'SPX Delta Levels',
     metainfo: {
       metainfoVersion: 53,
       id: "SPX Delta Levels@tv-basicstudies-1",
       description: "SPX Delta Levels",
       shortDescription: "SPX Delta Levels",
       format: { type: "price" },
       linkedToSeries: true,
       is_price_study: true,
       plots: [
         { id: "call_r1", type: "line" },
         { id: "call_r2", type: "line" },
         { id: "put_r1", type: "line" },
         { id: "put_r2", type: "line" }
       ],
       defaults: {
         styles: {
           call_r1: {
             linestyle: 0,
             linewidth: 1,
             transparency: 0,
             color: "#a40000",
           },
           call_r2: {
             linestyle: 1,
             linewidth: 1,
             transparency: 0,
             color: "#a40000",
           },
           put_r1: {
             linestyle: 0,
             linewidth: 1,
             transparency: 0,
             color: "#14f602",
           },
           put_r2: {
             linestyle: 1,
             linewidth: 1,
             transparency: 0,
             color: "#14f602",
           }
         },
       },
       styles: {
         call_r1: { title: "Delta Call R1" },
         call_r2: { title: "Delta Call R2" },
         put_r1: { title: "Delta Put R1" },
         put_r2: { title: "Delta Put R2" }
       },
       inputs: [],
     },
     constructor: function () {
       this._debugMode = true;

       this.init = function (ctx) {
         this._context = ctx;
       };

       this.main = function (ctx) {
         try {
           const { topOptions } = useGreeksWebsocketDataStore.getState();
           const spxOptions = topOptions.spx;

           if (!spxOptions?.length) {
             if (this._debugMode) {
               // console.log('[deltaLevelsGetter] No top options data');
             }
             return [NaN, NaN, NaN, NaN];
           }

           // Just get the current levels
           const deltaOptions = spxOptions.filter(opt => opt.greek_type === 'delta');

           // Get current levels exactly like dynamic levels
           const callR1 = deltaOptions.find(opt => opt.option_type === 'call' && opt.rank === 1)?.strike_price || NaN;
           const callR2 = deltaOptions.find(opt => opt.option_type === 'call' && opt.rank === 2)?.strike_price || NaN;
           const putR1 = deltaOptions.find(opt => opt.option_type === 'put' && opt.rank === 1)?.strike_price || NaN;
           const putR2 = deltaOptions.find(opt => opt.option_type === 'put' && opt.rank === 2)?.strike_price || NaN;

           // if (this._debugMode) {
           //   console.log('[deltaLevelsGetter] Levels:', {
           //     callR1,
           //     callR2,
           //     putR1,
           //     putR2,
           //     optionsCount: deltaOptions.length
           //   });
           // }

           // Return the same level for any point in time
           return [callR1 || NaN, callR2 || NaN, putR1 || NaN, putR2 || NaN];
         } catch (err) {
           console.error('[deltaLevelsGetter] Error in main:', err);
           return [NaN, NaN, NaN, NaN];
         }
       };

       this.destroy = function() {
         // No cleanup needed since we're not using subscriptions
       };
     },
   },
 ]);
};


